import { useTheme } from '@emotion/react'

import type { IconProps } from '@twistopayments/design-system/icons/constants'

import type { Color } from './types'

export const useColor = (statusColor?: Color) => {
  const theme = useTheme()

  let backgroundColor
  let textColor
  let iconColor: IconProps['color']

  switch (statusColor) {
    case 'success': {
      backgroundColor = theme.palette.success.lowContrast
      textColor = theme.palette.success.main
      iconColor = 'success'
      break
    }
    case 'warning': {
      backgroundColor = theme.palette.warning.lowContrast
      textColor = theme.palette.warning.main
      iconColor = 'warning'
      break
    }
    case 'error': {
      backgroundColor = theme.palette.error.lowContrast
      textColor = theme.palette.error.main
      iconColor = 'error'
      break
    }
    case 'primary': {
      backgroundColor = theme.palette.secondary.lowContrast
      textColor = theme.palette.secondary.mainContrast
      iconColor = 'highlight'
      break
    }
    default: {
      backgroundColor = theme.palette.primary.lowContrast
      textColor = theme.palette.text.title
      iconColor = 'textTitle'
      break
    }
  }

  return {
    backgroundColor,
    textColor,
    iconColor,
  }
}
